export function createPanelDetailPostProcessService(deps) {
    // 受注/納品予定/原価などを含む共通の明細表示後処理をまとめます。
    function postProcessPanelDetailRows(panelInfo, rows, options = {}) {
        let nextRows = Array.isArray(rows) ? rows : [];
        const buildContext = options.context ?? null;
        const entryData = options.entryData ?? null;
        const panelType = deps.getPanelType(panelInfo);

        // 品質表示は代表行へ集約します。
        if (deps.isQualityPanelType(panelType)) {
            nextRows = deps.buildQualityRepresentativeDisplayRows(nextRows, panelType, buildContext);
        } else if (deps.isFukushizaiSharedContextPanelInfo(panelInfo)) {
            // 副資材 shared context パネルは item/group で絞り込みます。
            nextRows = deps.filterRowsByFukushizaiContextIfKeyed(nextRows, buildContext);
        }

        // 品質表示の invalid row を除去します。
        nextRows = deps.filterInvalidRowsForPanel(nextRows, panelInfo);

        const demandType = deps.demandTypeKeyByPanel(panelInfo);

        // 受注表示を整形します。
        if (demandType === "130") {
            nextRows = deps.normalizeJutyuRows(nextRows);
        }

        // 納品予定表示を整形します。
        if (demandType === "131") {
            nextRows = deps.normalizeNouhinYoteiRows(nextRows);
        }

        // 原価表示用の補完行を追加します。
        if (deps.isGenkaGridPanelInfo(panelInfo)) {
            nextRows = deps.ensureGenkaDisplayRows(nextRows, entryData);
        }

        // 副資材の補助表示を付与します。
        nextRows = deps.decorateFukushizaiSupplementDisplayRows(nextRows, panelInfo, buildContext);

        // 品質表示以外のデメリット表示を整形します。
        if (!deps.isQualityPanelType(panelType) && deps.isDemeritPanelInfo(panelInfo)) {
            nextRows = deps.normalizeDemeritRows(nextRows);
        }

        // 品質表示以外の Wash 表示を整形します。
        if (!deps.isQualityPanelType(panelType) && deps.isWashPanelInfo(panelInfo)) {
            nextRows = deps.normalizeWashRowsForDisplay(nextRows);
        }

        // 組成表示を panel 単位で整形します。
        if (deps.isSoseiPanelInfo(panelInfo)) {
            nextRows = deps.normalizeSoseiRowsForPanel(nextRows, panelInfo);
        }

        return nextRows;
    }

    return {
        postProcessPanelDetailRows
    };
}
